<script setup lang="ts">
import type { CardTemplateProps } from '@/api/types';
import { getDocumentRouteFromListRoute } from '@/utilities/routeUtils';
import BlockStatusBar from '@/components/BlockStatusBar.vue';
import { useI18n } from 'vue-i18n';
import TagListRenderer from '@/components/TagListRenderer.vue';

const { t } = useI18n();

const props = defineProps<CardTemplateProps>();

const routeName = props.routeName ?? getDocumentRouteFromListRoute();
</script>

<template>
  <RouterLink
    :to="{ name: routeName, params: { blockId: block.blockId } }"
    :class="[
      'hover:bg-gnist-light-gray flex flex-col break-words rounded-md bg-gnist-white  text-gnist-black shadow-sm transition duration-300 ease-in-out hover:shadow-lg',
      'mt-[-1rem] w-full items-stretch p-6 first:mt-12',
    ]"
  >
    <div class="mb-4 flex items-center gap-2">
      <div
        :class="`bg-gnist-${block.category?.color ?? 'gray'}`"
        class="h-4 w-4 rounded-full"
      ></div>

      <div class="flex justify-between gap-4">
        <p v-if="block.category" class="text-box grow text-xs uppercase">
          {{
            `${block.category?.name} ${
              block.ownerOrg?.name &&
              block.category?.name !== t(`supplierPage.supplier`)
                ? ` ${t('blockList.from')} ${block.ownerOrg.name}`
                : ''
            }`
          }}
        </p>
      </div>
    </div>
    <TagListRenderer
      v-if="block.tags && block.tags.length > 0"
      :tags="block.tags"
      class="mb-3"
    />
    <div class="mt-1 flex flex-row">
      <h2 class="text-subtitle">
        {{ block.name }}
      </h2>
    </div>
    <p class="text-box mt-2 grow">
      {{ block.description }}
    </p>
    <div class="mb-[-0.5rem] mt-2 flex flex-row">
      <BlockStatusBar :block="block" />
    </div>
  </RouterLink>
</template>
